import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { P00039AntenneTypeEnum } from '../../../../P00039/Enum/P00039AntenneTypeEnum';
import { P0003600SeuilTemperatureFiltration2424 } from '../../../Enum/P0003600SeuilTemperatureFiltration2424';
import { getTemperatureType } from '../../../../../../helper/temperature';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';

@Component({
  selector: 'app-p0003600-filtration-mise-en-oeuvre-fonctionnalites-prevention',
  templateUrl:
    './p0003600-filtration-mise-en-oeuvre-fonctionnalites-prevention.component.html',
  styleUrls: [
    './p0003600-filtration-mise-en-oeuvre-fonctionnalites-prevention.component.scss',
  ],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    TranslatePipe,
    SwitchConfigurationComponent,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
  ],
})
export class P0003600FiltrationMiseEnOeuvreFonctionnalitesPreventionComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00039AntenneTypeEnum = P00039AntenneTypeEnum;
  protected readonly P0003600SeuilTemperatureFiltration2424 =
    P0003600SeuilTemperatureFiltration2424;
  protected readonly getTemperatureType = getTemperatureType;
}
